import { useState } from "react";
import { isWebLink, toMinorUnits } from "./marketingFormat";

const MAX_MESSAGE = 2000;
const INITIAL = {
  name: "",
  message: "",
  goal: "WEBSITE",
  link: "",
  headline: "",
  button: "LEARN_MORE",
  instagram: false,
  privacyUrl: "",
  askPhone: true,
  question: "",
  welcome: "",
  gender: "ALL",
  interests: [],
  costCap: "",
};

const blankToNull = (value) => (value.trim() ? value.trim() : null);

/** The wording, goal and audience of one new ad, with the validity and request body derived from them. */
export function useAdForm() {
  const [fields, setFields] = useState(INITIAL);
  const set = (name) => (value) => setFields((current) => ({ ...current, [name]: value }));
  const changeGoal = (goal) =>
    setFields((current) => ({
      ...current,
      goal,
      instagram: goal === "MESSAGES" ? false : current.instagram,
      button: goal === "LEADS" ? "SIGN_UP" : "LEARN_MORE",
    }));

  const costCapCents = toMinorUnits(fields.costCap);
  const costCapValid = fields.costCap.trim() === "" || costCapCents != null;
  const goalValid = {
    WEBSITE: isWebLink(fields.link),
    LEADS: isWebLink(fields.privacyUrl),
    MESSAGES: true,
    REACH: true,
  }[fields.goal];
  const valid =
    fields.name.trim() !== "" &&
    fields.message.trim() !== "" &&
    fields.message.length <= MAX_MESSAGE &&
    goalValid &&
    costCapValid;

  const payload = {
    name: fields.name.trim(),
    goal: fields.goal,
    message: fields.message.trim(),
    link: fields.goal === "WEBSITE" ? fields.link.trim() : null,
    headline: ["WEBSITE", "LEADS"].includes(fields.goal) ? blankToNull(fields.headline) : null,
    callToAction: ["WEBSITE", "LEADS"].includes(fields.goal) ? fields.button : null,
    leadForm:
      fields.goal === "LEADS"
        ? {
            privacyUrl: fields.privacyUrl.trim(),
            askPhone: fields.askPhone,
            question: blankToNull(fields.question),
          }
        : null,
    welcomeMessage: fields.goal === "MESSAGES" ? blankToNull(fields.welcome) : null,
    gender: fields.gender,
    interests: fields.interests.map(({ id, name }) => ({ id, name })),
    costCapCents: costCapCents,
  };

  return {
    fields,
    set,
    changeGoal,
    valid,
    costCapValid,
    payload,
    maxMessage: MAX_MESSAGE,
    resetInterests: () => set("interests")([]),
  };
}
